import type { FC } from "react";

type DocumentCardProps = {
  title: string;
  date: Date;
  document: React.ReactNode;
  src: string;
};

const DocumentCard: FC<DocumentCardProps> = ({
  title,
  date,
  document,
  src,
}) => {
  const handleClick = () => {
    window.open(src, "_blank");
  };

  return (
    <div
      className="bg-white shadow rounded-[20px] border border-brand-50 overflow-hidden cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex justify-center items-center bg-brand-50 h-48">
        {document}
      </div>
      <div className="p-4 border-t border-brand-50">
        <div className="font-semibold">{title}</div>
        <div className="text-sm">{`${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`}</div>
      </div>
    </div>
  );
};

export default DocumentCard;
